import { authFetch } from "../helpers/FetchHelpers";
const { default: DataService } = require("./DataService");

class InventoryDataService extends DataService {
    constructor() {
        super("inventory")
    }

    getStockReports(product_barcode, warehouse_id, date_start, date_end, page, per_page) {
        return authFetch(process.env.REACT_APP_API_URL + '/inventory/stock/history', 'POST', JSON.stringify({
            product_barcode,
            warehouse_id,
            date_start,
            date_end,
            page,
            per_page
        }));
    }

    getAlertedProductStocks() {
        return authFetch(process.env.REACT_APP_API_URL + '/inventory/stock/alert', 'GET', null)
            .then((data) => {
                return {
                    data: data.data !== null && data.data.errorMessage === undefined ? data.data : [],
                }
            })
    }
}

export default InventoryDataService;
